import { render, staticRenderFns } from "./ComplaintEmisorRegistration.vue?vue&type=template&id=52329db6"
import script from "./ComplaintEmisorRegistration.vue?vue&type=script&lang=js"
export * from "./ComplaintEmisorRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports